import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  Grid,
  Box,
  FormControl,
  FormLabel,
  Typography,
  FormControlLabel,
  FormGroup,
  Checkbox,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  checkboxGroupTitle: {
    color: theme.palette.text.primary
  }
}));

const Markets = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { allCountries = [], selectedCountries = [], handleChange, disabled } = props;

  const onChange = event => {
    const country = event.target.name;
    const isSelected = event.target.checked;
    const oldState = selectedCountries;
    let newState;

    if(isSelected) {
      // Add to list
      newState = [
        ...oldState,
        country
      ];
    } else {
      newState = oldState.filter(c => c !== country);
    }

    handleChange(newState);
  };

  return (
    <FormControl component="fieldset" fullWidth={true}>
      <FormLabel component="legend">
        <Typography variant="h6" component="h2" className={classes.checkboxGroupTitle}>{t('itemFamily:markets')}</Typography>
      </FormLabel>
      <Box p={3} border={1} borderColor="rgba(0, 0, 0, 0.1)" borderRadius={4} mt={3}>
        <FormGroup>
          <Grid container>
            {allCountries.map(country =>
              <Grid item xs={12} sm={4} key={country.id}>
                <FormControlLabel
                  control={<Checkbox checked={selectedCountries.includes(country.id) ? true : false} onChange={onChange} name={country.id} color="primary" />}
                  label={country.name}
                  disabled={disabled}
                />
              </Grid>
            )}
          </Grid>
        </FormGroup>
      </Box>
    </FormControl>

  );
};
Markets.propTypes = {
  allCountries: PropTypes.array,
  selectedCountries: PropTypes.array,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool
}

export default Markets;
